/**
 * The small caption-style label that sits above a filter control in
 * `ReportFilterCard` (Search, Market, etc.). Extracted so controls outside the
 * `fields/` folder (e.g. the Solutions Category/Folder picker) can render an
 * identical heading instead of the heavier admin-form `FieldLabel`.
 */
import React from 'react'
import { Typography } from '@mui/material'

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const FilterFieldLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography component="label" sx={labelStyle}>
    {children}
  </Typography>
)

export default FilterFieldLabel
